/// <reference path='../interfaces/interfaces.d.ts' />
'use strict';

angular.module('beneple.admin', []);


import './controllers/org_list';
import './services/crm.service';
import './services/report.service';



// WEBPACK FOOTER //
// ./frontend/scripts/admin/_module.ts